module.exports = __webpack_public_path__ + "img/fundacao.66fbc6f6.jpg";